/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import {
  PaginationParty,
  PartyType,
  useFilterPartiesLazyQuery,
} from "../../generated/graphql";
import useDebounce from "../../hooks/useDebounce";

import toast from "react-hot-toast";
import { useNavigate } from "react-router";
import SearchableContent from "../../Layout/SearchableContent";
import useInputSearch from "../../hooks/useInputSearch";
import { useAppDispatch, useAppSelector } from "../../hooks/usereduxHooks";
import { partyActionSuccess } from "../../store/actionCreator/party.creator";
import SearchPlaces from "../../utils/SearchPlaces";
import { formattedNum, limitAllItem } from "../../utils/constant";
import { selectOptionsForParty } from "../accountBalance/AccountBalanceDetails";

interface PartyProps {
  modalShow?: boolean;
  selectParty?: Function;
  selectedParty?: any;
}

export function Party({ modalShow, selectParty }: PartyProps) {
  const [search, setSearch] = useState("");

  const [searchKey, setSearchKey] = useState("partyName");
  const [crDr, setCrDrOption] = useState("");

  const [page] = useState(0);
  const [limit] = useState(limitAllItem);

  // useEffect(() => {
  //   KeyPress("PageDown", "shift").addListener((ev) => {
  //     console.log("askdfjlaskjdf");
  //   });
  // }, []);

  const { parties } = useAppSelector((store) => store.Party);

  const { ledgerBalance } = useAppSelector((store) => store.Ledger);

  const dispatch = useAppDispatch();

  // const [renderedTable, setRenderedTable] = useState<
  //   PaginationParty | undefined
  // >(undefined);

  const [filterPartiesQuery, { loading }] = useFilterPartiesLazyQuery();

  const fetchItem = async (searchInput?: string) => {
    const { data } = await filterPartiesQuery({
      variables: {
        findMatchPartyInput: {
          page: undefined,
          limit,
          partyName: search ? search?.trim() : "",
          orderKey: searchInput ?? searchKey,
          crDr: crDr ? crDr : undefined,
        },
      },
      fetchPolicy: "no-cache",
    });

    dispatch(partyActionSuccess(data?.filterParties as PaginationParty));
    if (searchInput) {
      toast.success("Sorting completed", { duration: 2000 });
    }
  };

  useEffect(() => {
    if (ledgerBalance?.items?.length) {
      return;
    }
    fetchItem();
  }, []);

  useDebounce(() => fetchItem(), 300, [search, searchKey, modalShow, page, limit, crDr]);

  const Columns = ["Party Code", "Party Name", "City", "Mobile Number"];

  const RightColumn = ["Initial Balance", "Balance", "CR/DR", "Since Due"];

  const SelectPartyColumn = [
    "Party Code",
    "Party Name",
    "City",
    "Balance",
    "CR/DR",
  ];

  const navigate = useNavigate();

  const filterSorting = (parameter: number) => {
    try {
      const searchPerameter = selectOptionsForParty[parameter];
      if (searchPerameter) {
        setSearchKey(searchPerameter.value);
        fetchItem(searchPerameter.value);
        toast.loading(`Sorting by ${searchPerameter.name}, Please wait...`, {
          duration: 2000,
        });
      }
    } catch (err) {}
  };

  useInputSearch({ filterSorting });

  return (
    <SearchableContent className={searchKey}>
      <div>
        {!modalShow && (
          <Box
            display="flex"
            alignItems={{ xs: "stretch", md: "center" }}
            flexDirection={{ xs: "column", md: "row" }}
            justifyContent="space-between"
          >
            <Box display="flex" alignItems="center" justifyContent={"flex-start"}>
              <Box
                display="flex"
                alignItems="flex-start"
                flexDirection={"column"}
                justifyContent={"flex-start"}
                marginBottom={{ xs: "20px", md: "0px" }}
              >
                <Typography variant="h3" component="h3" gutterBottom>
                  {"Accounts"}
                </Typography>
                <Typography variant="subtitle2">Manage Account</Typography>
              </Box>
            </Box>
          </Box>
        )}

        <SearchPlaces
          selectOptions={selectOptionsForParty}
          setSearchKey={setSearchKey}
          searchKey={searchKey}
          selectOptionsType={[
            { name: "DR", value: "DR" },
            { name: "CR", value: "CR" },
          ]}
          hideSearch={false}
          FieldName="Search party name..."
          md={12}
          crDr={crDr}
          onSelectCrDrOptions={setCrDrOption}
          search={search}
          setSearch={setSearch}
        />

        <Box sx={{ overflowX: "auto", width: "100%" }}>
          <TableContainer>
            {loading && (
              <div className="loading-overlay">
                <CircularProgress />
              </div>
            )}

            <Table size={modalShow ? "small" : "medium"} sx={{ minWidth: modalShow ? 480 : 650 }}>
              <TableHead>
                <TableRow>
                  {modalShow ? (
                    SelectPartyColumn.map((value) => {
                      return (
                        <TableCell
                          key={value}
                          align={
                            ["Balance", "CR/DR"].includes(value)
                              ? "right"
                              : "left"
                          }
                          sx={{ whiteSpace: "nowrap", py: 1 }}
                        >
                          {value}
                        </TableCell>
                      );
                    })
                  ) : (
                    <>
                      {Columns.map((value) => {
                        return (
                          <TableCell key={value} align="left">
                            {value}
                          </TableCell>
                        );
                      })}
                      {RightColumn.map((value) => {
                        return (
                          <TableCell key={value} align="right">
                            {value}
                          </TableCell>
                        );
                      })}
                    </>
                  )}
                </TableRow>
              </TableHead>
              <TableBody sx={{ overflow: "auto" }}>
                {parties?.items?.map((item: PartyType) => (
                  <TableRow
                    onClick={() => {
                      if (selectParty) {
                        selectParty(item);
                      } else {
                        navigate(`/accounts/add-party/${item.partyCode}`);
                      }
                    }}
                    hover
                    key={item.id}
                    sx={{ cursor: "pointer" }}
                  >
                    <TableCell sx={{ py: 1 }}>
                      <Typography
                        variant="body2"
                        fontWeight="bold"
                        color="text.primary"
                        noWrap
                        className="partyCode"
                      >
                        {item.partyCode}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ py: 1 }}>
                      <Typography
                        className="partyName"
                        variant="body2"
                        fontWeight="bold"
                        color="text.primary"
                        noWrap
                      >
                        {item.partyName}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ py: 1 }}>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        noWrap
                        className="city"
                      >
                        {item.city || "—"}
                      </Typography>
                    </TableCell>

                    {!modalShow && (
                      <>
                        <TableCell sx={{ py: 1 }}>
                          <Typography
                            variant="body2"
                            noWrap
                          >
                            {item.phoneNumber ? item.phoneNumber : "N/A"}
                          </Typography>
                        </TableCell>
                        <TableCell align="right" sx={{ py: 1 }}>
                          <Typography
                            variant="body2"
                            noWrap
                          >
                            {formattedNum(Math.abs(item.openingBalance!))}
                          </Typography>
                        </TableCell>
                      </>
                    )}

                    <TableCell align="right" sx={{ py: 1 }}>
                      <Typography
                        variant="body2"
                        fontWeight="bold"
                        noWrap
                      >
                        {formattedNum(Math.abs(item.balance!))}
                      </Typography>
                    </TableCell>

                    <TableCell align="right" sx={{ py: 1 }}>
                      <Typography
                        variant="body2"
                        fontWeight="bold"
                        noWrap
                        color={item?.balance! > 0 ? "success.main" : item?.balance! < 0 ? "error.main" : "text.secondary"}
                      >
                        {item?.balance! > 0 ? "DR" : item?.balance! < 0 ? "CR" : "—"}
                      </Typography>
                    </TableCell>

                    {!modalShow && (
                      <TableCell align="right" sx={{ py: 1 }}>
                        <Typography
                          variant="body2"
                          noWrap
                        >
                          N/A
                        </Typography>
                      </TableCell>
                    )}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        {/* <Box p={2}>
        <TablePagination
          component="div"
          count={-1}
          onPageChange={(e, number) => {
            setPage(number);
          }}
          page={page}
          onRowsPerPageChange={(e) => setLimit(Number(e.target.value))}
          rowsPerPage={limit}
          rowsPerPageOptions={[15, 30, 50, 100]}
        />
      </Box> */}
      </div>
    </SearchableContent>
  );
}
